export const normalPlayer = [
  {
    name: '',
    color: '#26C6DA',
    points: [1, 2, 3],
    categories: [12],
    negative: false,
    translationKey: 'chalkboard.offensive.player.goals',
  },
  {
    name: '',
    color: '#305496',
    points: [1, 2, 3],
    categories: [10],
    negative: false,
    translationKey: 'chalkboard.offensive.player.assists',
  },
  {
    name: '',
    color: '#000066',
    points: [1, 2, 3],
    categories: [27],
    translationKey: 'chalkboard.offensive.player.participation_in_goals',
  },
  {
    name: '',
    color: '#FFFF00',
    points: [1, 2, 3],
    categories: [510],
    translationKey: 'chalkboard.offensive.player.shots_on_goal',
  },
  {
    name: '',
    color: '#9933FF',
    points: [1, 2, 3],
    categories: [537, 540, 544, 547],
    translationKey: 'chalkboard.offensive.player.shots_on_goal_2',
  },
  {
    name: '',
    color: '#FFA726',
    points: [1, 2, 3],
    categories: [13, 25],
    translationKey: 'chalkboard.offensive.player.center_crosses',
  },
  {
    name: '',
    color: '#4DB6AC',
    points: [1, 2, 3],
    categories: [98, 101, 104, 105, 109, 112, 115, 116],
    translationKey: 'chalkboard.offensive.player.successful_center_crosses',
  },
  {
    name: '',
    color: '#F06292',
    points: [1, 2],
    categories: [11],
    translationKey: 'chalkboard.offensive.player.balls_won_opponent_penalty_box',
  },
  {
    name: '',
    color: '#3A3838',
    points: [1],
    categories: [4],
    translationKey: 'chalkboard.offensive.player.successful_1_on_1_attacking',
  },
  {
    name: '',
    color: '#00B050',
    points: [1],
    categories: [208],
    translationKey: 'chalkboard.offensive.player.unsuccessful_1_on_1_attacking',
  },
];

export const goalkeeper = [
  {
    name: '',
    color: '#F06292',
    points: [1, 2, 3],
    categories: [44],
    translationKey: 'chalkboard.offensive.goalkeeper.footwork',
  },
  {
    name: '',
    color: '#9C27B0',
    points: [1, 2],
    categories: [302],
    translationKey: 'chalkboard.offensive.goalkeeper.throw',
  },
  {
    name: '',
    color: '#455A64',
    points: [1, 2],
    categories: [303],
    translationKey: 'chalkboard.offensive.goalkeeper.punt',
  },
  {
    name: '',
    color: '#000066',
    points: [1, 2, 3],
    categories: [323],
    translationKey: 'chalkboard.offensive.goalkeeper.participation_in_goals',
  },
  {
    name: '',
    color: '#305496',
    points: [1, 2],
    categories: [324],
    translationKey: 'chalkboard.offensive.goalkeeper.assist',
  },
  {
    name: '',
    color: '#FFA726',
    points: [1, 2],
    categories: [264],
    translationKey: 'chalkboard.offensive.goalkeeper.goal_kick',
  },
];

export const allCategories = [...normalPlayer, ...goalkeeper];
